<template>
  <bkf-action
    :disabled="disabled"
    :tooltip="$trans('v2.i2m_components.actions.download')"
    @click="download"
  >
    <v-icon>
      mdi-cloud-download
    </v-icon>
  </bkf-action>
</template>

<script>
import api from '@services/api';

export default {
  props: {
    url: {
      type: String,
      default: '',
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async download() {
      const { status, data, headers } = await api.get(
        this.url,
        {
          params: this.params,
          responseType: 'blob',
        },
      );

      if (status === 200) {
        const filetype = headers['content-type'] || 'application/octet-stream';

        let fileName = 'file';

        // spróbuj pobrać nazwę z nagłówka
        const disposition = headers['content-disposition'];
        if (disposition) {
          const match = disposition.match(/filename="?([^"]+)"?/);
          if (match && match[1]) {
            fileName = decodeURIComponent(match[1]);
          }
        }

        const blob = new Blob([data], { type: filetype });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
      }
    },
  },
};
</script>
